import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Theme, Box, Grid, InputLabel, Typography
} from '@material-ui/core/';
import * as actions from "../../../../store/actions/index";
import moment from "moment";
import ValidateForm from "../../../../helper/validations";
import { withStyles } from '@material-ui/core/styles'
import {Styles} from "@material-ui/core/styles/withStyles";
import CircularProgress from '@material-ui/core/CircularProgress';
import CancelIcon from '@material-ui/icons/ClearSharp';
import Config from "../../../../config/config";
import Alert from '@material-ui/lab/Alert';
import {Helmet} from "react-helmet";
import OtpInput from 'react-otp-input';
const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
import clsx from 'clsx';

const useStyles: Styles<Theme, any, any> = () =>({
  appBar: {
    position: 'relative',
    background: 'none',
    boxShadow: 'none',
  },
  toolBar: {
    minHeight: 50,
  },
  layout: {
    marginLeft: '0 auto',
    marginRight: '0 auto',
    paddingLeft: '20px',
    paddingRight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#fdca42',
    width: '100vw',

    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },
  label: {
    color: '#19191e',
    "&$focusedLabel": {
      color: "#6667AB"
    },
    "&$erroredLabel": {
      color: "#6667AB"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#19191e',
    "&$error:after": {
      borderBottomColor: "#6667AB"
    },
    "&:after": {
      borderBottom: `2px solid #6667AB`
    }
  },
  error: {},
  textCenter: {
    textAlign: 'center',
    color: '#19191e'
  },
  headline: {
    '@media (max-width: 960px)': {
      fontSize: '3.5rem',
    },
    '@media (max-width: 600px)': {
      fontSize: '2.5rem',
    },
  },
  logoFont: {
    fontFamily: 'Pacifico',
    color: '#6667AB'
  },

  actionButtons: {
    marginTop: '20px',
    minWidth: '460px',
    marginBottom: '20px',
    '@media (max-width: 760px)': {
      minWidth: '250px'
    },
    color: '#6667AB',
    border: '1px solid rgba(102, 103, 171, 0.5)',
    '&:hover': {
			border: '1px solid #6667AB',
      backgroundColor: 'rgba(102, 103, 171, 0.2)'
		},
  },


  passwordCheckRow: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 300,
    fontFamily: 'roboto-regular',
    textAlign: "left",
  },
  passwordInput: {
    width: '100%',
    "& .MuiInputAdornment-positionEnd": {
      margin: "0!important",
    },
  },
  otpInput: {
    width: '100%',
    "& .MuiInputAdornment-positionEnd": {
      margin: "0!important",
    },
  },
  //general
  registerlogocontainer:{
    textAlign:"left", 
    marginTop:"22px", 
    marginLeft:"40px",
    '@media (max-width: 768px)': {
      margin:"0 auto",
      paddingTop:"20px",
      textAlign:"center", 
      width:"100%"
    },
  },
  registerLogo:{
    width: "188px",
    height: "27px",
    '@media (max-width: 768px)': {
      width:"100%"
    },
  },
  description_smart:{
    textAlign:"center",
    font: "normal normal bold 24px/26px Spartan-bold",
    color: "#6667AB",
  },
  description2:{
    textAlign:"center",
    font: "normal normal bold 36px/26px Spartan-bold",
    color: "#19191e",
    opacity: "1",
    marginBottom: "10px"
  },
  //general
  bottomleft:{
    textAlign:"left",
    '@media (max-width: 960px)': {
      textAlign:"center"
    },
  },
  bottomimageleft:{
    width: "354px",
    height: "161px",
    marginTop:"140px",
    marginLeft:"30px",
    '@media (max-width: 767px)': {
      margin:"0 auto",
      maxWidth: "354px",
      width:"100%"
    },
  },
  bottomright:{
    textAlign:"right",
    '@media (max-width: 960px)': {
      textAlign:"center",
    },
  },
  bottomimageright:{
    width: "374px",
    // height: "260px",
    marginRight:"30px",
    '@media (min-width: 768px) and (max-width:992px)': {
      marginRight:"0",
    },
    '@media (max-width: 767px)': {
      margin:"0 auto",
      width:"100%",
      maxWidth: "374px",
    },
  },
  otpInputBox:{
    display:'inline-flex',
    textAlign:'center'
  },
  otpInputItem:{
    height:30,
    minWidth:30,
    margin:5
  },
  verificationLabel: {
    marginTop:25,
    marginBottom:10,
    color: '#19191e'
  }
});

interface IProps {
  history: any,
  notification: any,
  apolloClient: any,
  resetPassword: (client: any, requestData: any, history: any) => void,
  classes: any
}

interface IState {
  errors: any,
  email: string,
  password: string,
  code: string,
  expiredin: string,
  error: any,
  isShownPassword: boolean,
  is_length: boolean,
  is_lowercase: boolean,
  is_uppercase: boolean,
  is_number: boolean,
  // is_special_character: boolean,
  is_confirm: boolean,
  loading: boolean,
  passwordValid: boolean,
  [key: string]: any,
  successMsg:string,
  errorMsg:string,
  emailField:any
}

class ResetPassword extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    const emailField = createRef<null>();

    this.state = {
      errors: {},
      email:"",
      password: "",
      code:"",
      expiredin:"",
      error: { password: "" },
      isShownPassword: true,
      is_length: false,
      is_lowercase: false,
      is_uppercase: false,
      is_number: false,
      // is_special_character: false,
      is_confirm: false,
      loading: false,
      passwordValid: false,
      errorMsg:"",
      successMsg:"",
      emailField: emailField,
    };
  }

  // get data from url 
  getQueryString = (field: any, url?: string) => {
    const href = url ? url : window.location.href;
    const reg = new RegExp("[?&]" + field + "=([^&#]*)", "i");
    const string = reg.exec(href);
    return string ? string[1] : null;
  };

  // load init data
  componentDidMount() {
    // const exptime = moment().utc().valueOf() + (1000 * 60 * 5);
    this.setState({
      password: "",
      code: this.getQueryString("code") || "",
      email: this.getQueryString("email") || "",
      expiredin: this.getQueryString("expiredin") || "",
    },
      () => {
        this.forceUpdate();
        if (this.state.expiredin) {
          if (moment().utc().valueOf() > Number(this.state.expiredin)) {
            // toast.error("This link is expired,please resend again", {
            //   position: "top-right",
            //   autoClose: 5000,
            //   hideProgressBar: true,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            // });
            this.props.history.push("/user/forgot-password")
          } else {
            // this.sendForgotPasswordOtp()
          }
        }
      }
    )

    setTimeout(() => {
      this.setState({password: ""});
    }, 100);
  }

  // when receive update from reducer
  UNSAFE_componentWillReceiveProps(props: IProps) {
    if (props.notification) {
      this.setState({ loading: false })
      if(props.notification.message && !props.notification.success) {
        this.setState({
          errorMsg: props.notification.message
        })
      }
    }
  }

  // show password
  togglePasswordVisibility = () => {
    const { isShownPassword } = this.state;
    this.setState({ isShownPassword: !isShownPassword });
  };

  // validation for new password
  validatePassword = (event: any) => {
    const fieldValue = event.target.value;
    const rules = [
      {
        Pattern: "[A-Z]",
        Target: "UpperCase",
      },
      {
        Pattern: "[a-z]",
        Target: "LowerCase",
      },
      {
        Pattern: "[0-9]",
        Target: "Numbers",
      },
    ];
    if (fieldValue.length > 7) {
      this.setState({ is_length: true },
        () => { this.forceUpdate(); }
      );
    } else {
      this.setState(
        { is_length: false, },
        () => { this.forceUpdate(); }
      );
    }

    for (let i = 0; i < rules.length; i++) {
      if (new RegExp(rules[i].Pattern).test(fieldValue)) {
        if (rules[i].Target === "UpperCase") {
          this.setState({ is_uppercase: true, });
        } else if (rules[i].Target === "LowerCase") {
          this.setState({ is_lowercase: true });
        } else if (rules[i].Target === "Numbers") {
          this.setState({ is_number: true },
            // function () { }
          );
        }
      }
      if (!new RegExp(rules[i].Pattern).test(fieldValue)) {
        if (rules[i].Target === "UpperCase") {
          this.setState({
            is_uppercase: false,
          });
        } else if (rules[i].Target === "LowerCase") {
          this.setState({
            is_lowercase: false,
          });
        } else if (rules[i].Target === "Numbers") {
          this.setState({
            is_number: false,
          });
        } 
      }
    }

    const input = event.target.value;
    const errors: any = {};
    if (!input) {
      errors[event.target.name] = "Please enter password";
    } else { errors[event.target.name] = "" }

    this.setState({
      errors: {
        ...this.state.errors,
        [event.target.name]: errors[event.target.name]
      },
      [event.target.name]: event.target.value
    });
  };

  // when submit password form
  onSubmit = (e: any) => {
    e.preventDefault();
    const requestData = {
      password: this.state.password,
      email: this.state.email ? decodeURIComponent(this.state.email) : "",
      code:this.state.code
    };
    const validateError = ValidateForm.validateResetPasswordForm(requestData);
    if (!Object.keys(validateError).length) {
      this.setState({ errors: {} });
      this.setState({ loading: true, errorMsg:"", successMsg:""});
      this.props.resetPassword(this.props.apolloClient.client, requestData, this.props.history);
    } else {
      this.setState({ errors: validateError })
    }
  };

  // when change field
  onChange = (event: any) => {
    this.setState({ [event.target.name]: event.target.value })
  };

  // when change otp field
  onChangeOtp = (code: any) => {
    if(code && code.length <= 6){
      this.setState({ code: code });
    }
  };

  sendForgotPasswordOtp = () => {
    const poolData = {
      UserPoolId: Config.CONFIG.USER_POOL, // Your user pool id here
      ClientId: Config.CONFIG.CLIENT_ID, // Your client id here
    };
    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    const userData = {
      Username: this.state.email ? decodeURIComponent(this.state.email.toLowerCase().trim()):"",
      Pool: userPool,
    };

    const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    const _this = this
    cognitoUser.forgotPassword({
      onSuccess: function () {
        _this.setState({
          successMsg:"We have sent a One Time Password to your email address, please check your email account."
         })
      },
      onFailure: function (error: any) {
        let message = "Problem occurred while send One Time Password. Please try again to reopen this link or resend the forgot password email"
        if(error.message){
          message = error.message
        }
        _this.setState({
          errorMsg:message
        })
      },
    });
  }

  render() {
    const {
      is_length,
      is_number,
      is_uppercase,
      is_lowercase,
      // is_special_character,
      isShownPassword,
      loading,
      code,
      errorMsg,
      successMsg
    } = this.state;
    const { classes } = this.props;

    
    return (
      <React.Fragment>
        <Helmet title="Reset Password"/>
        
        <div className={classes.layout}>
        <Grid container spacing={3}>
        <Grid item xs={12} sm={6}  style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <img src="/assets/images/lively/meeting_02.png" />
              </Grid>

              <Grid item xs={12} sm={6} >

          <Box className="w-100">
          <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)}>Make the unknown, known.</Typography>

 
            <div className="login-form">
              <form noValidate onSubmit={this.onSubmit}>
                
                <InputLabel className={classes.verificationLabel}>Enter Your Verification Code</InputLabel>
                <div className={`ResetPassword-otpInputItem ${classes.otpInputBox}`}>
                  <OtpInput
                    value={this.state.code}
                    onChange={this.onChangeOtp}
                    numInputs={7}
                    separator={<span>-</span>}
                    inputStyle={classes.otpInputItem}
                    isInputNum={true}                    
                  />
                </div>
                <br/>
                <input type="text" name="password" style={{display:"none"}}/>
                <TextField
                  InputLabelProps={{
                    classes: {
                      root: classes.label,
                      focused: classes.focusedLabel,
                      error: classes.erroredLabel
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.underline,
                      error: classes.error
                    },
                    autoComplete:'new-password',
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="password-visible-btn"
                          onClick={this.togglePasswordVisibility}
                          aria-label="toggle password visibility"
                        >
                          {
                            !this.state.isShownPassword ? <img src='/assets/images/eye-show-visible.svg' alt="show"/>
                                                        : <img src='/assets/images/eye-hidden.svg' alt="hidden"/>
                          }
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  ref={this.state.emailField}
                  className={classes.passwordInput}
                  margin="normal"
                  id="password"
                  label="Create New Password"
                  type={isShownPassword ? "password" : "text"}
                  name="password"
                  onChange={this.validatePassword}
                  value={this.state.password}
                />
                <div className={classes.passwordCheckRow}>
                  {is_length ? "" : <><CancelIcon style={{ marginRight: 10 }} color="error" /> Password must be at least 8 characters</>}
                </div>
                <div className={classes.passwordCheckRow}>
                  {is_number ? "" : <><CancelIcon style={{ marginRight: 10 }} color="error" /> Password must contain at least one number</>}
                </div>
                <div className={classes.passwordCheckRow}>
                  {is_uppercase ? "" : <><CancelIcon style={{ marginRight: 10 }} color="error" /> Password must contain at least one upper-case letter</>}
                </div>
                <div className={classes.passwordCheckRow}>
                  {is_lowercase ? "" : <><CancelIcon style={{ marginRight: 10 }} color="error" /> Password must contain at least one lower-case letter</>}
                  
                </div>
          
                <Button
                  type="submit"
                  variant="outlined"
                  className={classes.actionButtons}
                  color="secondary"
                  disabled={loading || !(is_length && is_number && is_uppercase && is_lowercase  && code && code.length === 6)}
                >
                  {loading && <CircularProgress color="inherit" size={20}/>}
                  {!loading && <p style={(is_length && is_number && is_uppercase && is_lowercase && code && code.length === 6 ) ? {} : { }}>Save</p>}
                </Button>
                <br /><br />
                { errorMsg && <Alert icon={false} className="error-alert" severity="error">{errorMsg}</Alert> }
                { successMsg && <Alert icon={false} className="error-alert" severity="success">{successMsg}</Alert> }
              </form>
            </div>
          </Box>
          </Grid>
              </Grid>
        </div>
        
      </React.Fragment>
    );
  }
}

// load reducers
const mapStateToProps = (state: any) => ({
  authUser: state.authUser,
  apolloClient: state.apolloClient,
  notification: state.notification
});

// load actions
const mapDispatchToProps = (dispatch: any) => {
  return {
    resetPassword: (client: any, request: any, history: any) => {
      dispatch(actions.resetPassword(client, request, history));
    },

  }
};

const WondrResetPasswordComponent = withStyles(useStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(ResetPassword));

export {
  WondrResetPasswordComponent
}
